var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-chart-wrapper',[_c('div',{staticClass:"card-header flex-space-between"},[_c('div',[_vm._v(_vm._s(_vm.$t('message.statistics.message.screenTime'))+": "+_vm._s(_vm.screenTime)+"s")])]),_c('h4',{staticClass:"text-muted text-center my-4 white-space-normal"},[_vm._v("\n    "+_vm._s(_vm.stats.description)+"\n  ")]),_c('canvas',{ref:"chart"})])
}
var staticRenderFns = []

export { render, staticRenderFns }